/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import i18next from 'i18next';
// import Polyglot from 'i18next-polyglot';
import { initReactI18next } from 'react-i18next';

import translationES from './es/translation.json';
import translationEN from './en/translation.json';

const { PATHS_LOCATIONS } = require('./autoGeneratedPathsLocations');
const NAMESPACE_FALLBACKS = {
  SalesDashboard: 'DashboardMC',
  Common: 'CommonMC'
};

const resources = {
  es: {
    translation: translationES,
    ...PATHS_LOCATIONS.es
  },
  en: {
    translation: translationEN,
    ...PATHS_LOCATIONS.en
  },
  pt: {
    ...PATHS_LOCATIONS.pt
  }
};

i18next
  .use(initReactI18next)
  // NOTE: Commented out because it causes an error that not scape the values
  // .use(Polyglot)
  .use({
    type: 'backend',
    read: (language, namespace, callback) => {
      const loadNamespace = (nsName) => import(`./${language}/${nsName}.json`);

      loadNamespace(namespace)
        .then((res) => {
          callback(null, res.default || res);
        })
        .catch((error) => {
          const isMissingNamespaceError = /Cannot find module/i.test(error?.message || '');
          const fallbackNamespace = NAMESPACE_FALLBACKS[namespace];

          if (isMissingNamespaceError && fallbackNamespace) {
            loadNamespace(fallbackNamespace)
              .then((fallbackRes) => {
                console.warn(`[i18n] Namespace alias applied: ${namespace} -> ${fallbackNamespace}`);
                callback(null, fallbackRes.default || fallbackRes);
              })
              .catch((fallbackError) => {
                callback(fallbackError, null);
              });
            return;
          }

          if (isMissingNamespaceError) {
            console.warn(`[i18n] Missing namespace file: ${language}/${namespace}.json`);
            callback(null, {});
            return;
          }
          callback(error, null);
        });
    }
  })
  .init({
    resources,
    defaultNS: "translation",
    fallbackLng: 'es',
    lng: ENV.CURRENT_AGENT_LANG || navigator.language.split('-')[0] || 'es',
    interpolation: {
      escapeValue: false,
      ignoreAttributes: ["className", /.*ClassName$/]
    },
    debug: false
  });

// export default i18next;
